/**
 * Die Wellenformen der Medien, einmal geholt und behalten.
 *
 * Für den Pegelmesser (28./30. Oktober): Ton, der nicht durch die Tonkette
 * läuft -- aus einem Videoclip oder aus dem fertigen Vorschau-Film --, misst
 * der Messer nicht am Klang, sondern liest ihn aus der Wellenform an der
 * Stelle, an der der Kopf steht. Die Wellenform entsteht beim Einlesen
 * ohnehin (20 Spitzen je Sekunde, 0…1).
 */

type Eintrag = number[] | 'laedt' | 'fehlt';

const vorrat = new Map<string, Eintrag>();

/** Die Spitzen dieser Wellenform, oder `null`, solange sie (noch) nicht da ist. */
export function welle(url: string): number[] | null {
  const da = vorrat.get(url);
  if (Array.isArray(da)) return da;
  if (da) return null;
  vorrat.set(url, 'laedt');
  void fetch(url)
    .then((r) => (r.ok ? (r.json() as Promise<{ peaks?: number[] }>) : null))
    .then((w) => vorrat.set(url, Array.isArray(w?.peaks) ? w.peaks : 'fehlt'))
    .catch(() => vorrat.set(url, 'fehlt'));
  return null;
}

/** Die Spitze an dieser Stelle der Datei, 0…1 -- die zwei Eimer um sie herum. */
export function spitzeBei(peaks: readonly number[], dauer: number, sekunde: number): number {
  if (peaks.length === 0 || !(dauer > 0)) return 0;
  const i = Math.floor((sekunde / dauer) * peaks.length);
  if (i < 0 || i >= peaks.length) return 0;
  return Math.max(peaks[i] ?? 0, peaks[i + 1] ?? 0);
}
